export const nnMoment = {
  months: [
    'Januar',
    'Februar',
    'Mars',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Desember'
  ],
  // Lowercase, as Norwegian writes them, and without a dot: deadlineDateFormat adds one (#229).
  monthsShort: ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'],
  relativeTime: {
    future: 'i %s',
    past: '%s sidan',
    m: '%d minutt',
    mm: '%d minutt',
    s: '%d sekund',
    ss: '%d sekund',
    h: 'ein time',
    hh: '%d timar',
    d: 'ein dag',
    dd: '%d dagar',
    M: 'ein månad',
    MM: '%d månader',
    y: 'eitt år',
    yy: '%d år'
  }
};
